export default __webpack_public_path__ + "static/media/kaura.7a5d8f0e.png";